// handle dropdowns
export function registerDropdowns() {
  const dropdowns = document.getElementsByClassName("dropdown-toggle");

  for (let dropdown of dropdowns) {
    const dropdownList = dropdown.nextElementSibling;
    let open = !dropdownList.classList.contains("hidden");

    dropdown.addEventListener("click", (e) => {
      e.stopImmediatePropagation();

      if (open) {
        dropdownList.classList.add("hidden");
        open = false;

        if (window.innerWidth < 750) {
          document.body.classList.remove("locked");
        }
      } else {
        dropdownList.classList.remove("hidden");
        open = true;

        function hideOnClick() {
          open = false;
          dropdownList.classList.add("hidden");
          if (window.innerWidth < 750) {
            document.body.classList.remove("locked");
          }
          document.removeEventListener("click", hideOnClick);
        }

        document.addEventListener("click", hideOnClick);

        if (window.innerWidth < 750) {
          document.body.classList.add("locked");
        }
      }
    });
  }
}
